<template>
  <div id="printable">
    <v-table
      :row-active-id="rowActiveId"
      :data="tableData"
      :columns="columns"
      clickable
      @row-click="onRowClick"
      @row-dblclick="isModal = true"
    >
      <template v-slot:column-time="item">
        <p v-if="item.row.isNew" :class="$style.new">
          NEW
        </p>
        {{ item.row.date | dateTime }}
      </template>
      <template v-slot:column-subject="item">
        [{{ item.row.type | type }}] {{ item.row.subject }}
      </template>
      <template v-slot:column-to="item">
        {{ item.row.attachments.length ? '📎 ' : '' }}{{ item.row.to }}
      </template>
      <template v-slot:column-username="item">
        <span :class="$style.dangerous">
          <dangerous :value="item.row.statusDangerous" />
        </span>
        {{ item.row.username }}
      </template>
    </v-table>
    <additional v-if="rowActiveId" v-bind="activeRow" />
    <modal v-if="isModal" :title="activeRow.subject" @close="isModal = false">
      <iframe :class="$style.iframe" :srcdoc="activeRow.textRaw || activeRow.text" sandbox />
    </modal>
  </div>
</template>

<script>
import VTable from '@/components/common/table/table.vue';
import Modal from '@/components/common/modal/index.vue';
import { dateTime } from '@/helpers/filters';
import Dangerous from '@/components/common/dangerous/index.vue';
import { LogData } from '@/domains/log/data';
import Additional from './components-default/additional.vue';
import { type } from './utils';

export default {
  components: {
    VTable,
    Additional,
    Dangerous,
    Modal,
  },
  filters: {
    dateTime,
    type,
  },
  props: {
    data: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {
          field: 'time',
          title: this.$t('pages.columns.time'),
          sortFn: (isAsc) => (a, b) => (a.date - b.date) * (isAsc ? 1 : -1),
        },
        { field: 'subject', title: this.$t('pages.columns.subject') },
        { field: 'from', title: this.$t('pages.columns.from') },
        { field: 'to', title: this.$t('pages.columns.to') },
        { field: 'username', title: this.$t('pages.columns.username') },
      ],

      isModal: false,
    };
  },
  computed: {
    rowActiveId() {
      return parseInt(this.$route.params.record, 10);
    },
    tableData() {
      return LogData.filterTable(
        this.data,
        [
          (item) => dateTime(item.date),
          (item) => dateTime(item.dateSend),
          'subject',
          'from',
          'to',
          'server',
          'username',
        ],
        this.$route.query.filter,
      );
    },
    activeRow() {
      const activeRow = this.data.find((i) => i.id === this.rowActiveId);

      return activeRow || {};
    },
  },
  created() {
    this.$store.commit('logs/printData/setColumns', this.columns);
  },
  methods: {
    onRowClick(id) {
      this.$router.push({
        name: 'computers-computer-log-record',
        params: { record: id },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" module>
  .new {
    display: inline-block;
    background: $light-blue;
    color: $blue;
    font-size: 7px;
    padding: 3px;
    margin-right: 8px;
    border-radius: 1px;
  }

  .dangerous {
    display: inline-block;
    margin-right: 8px;
  }

  .iframe {
    width: 100%;
    height: 600px;
  }
</style>
